import ReactModal from "react-modal";
import VButton from "./VButton";

interface ConfirmModalProps {
  isOpen: boolean;
  close: () => void;
  title: string;
  message: string;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  status?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  close,
  title,
  message,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  status,
}) => {
  return (
    <ReactModal
      shouldCloseOnOverlayClick={true}
      onRequestClose={close}
      isOpen={isOpen}
      className="h-screen w-screen"
    >
      <div
        onClick={close}
        className="h-full w-full bg-gray-500 bg-opacity-50 flex items-center justify-center"
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-white rounded-lg p-8 max-w-md w-full mx-4"
        >
          <h2 className="text-2xl font-semibold mb-4">{title}</h2>
          <p className="text-gray-600 mb-8">{message}</p>
          <div className="flex gap-4 justify-end">
            <VButton
              onClick={close}
              className="py-2 px-6 bg-gray-300 text-gray-800 rounded-lg"
            >
              {cancelText}
            </VButton>
            <VButton
              onClick={onConfirm}
              status={status}
              className="py-2 px-6 bg-black text-white rounded-lg"
            >
              {confirmText}
            </VButton>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default ConfirmModal;
